<div *ngIf="!emailSent" class="contact-us">
  <c11n-banner
    [iconName]="'announcement'"
    [headingText]="'contactUs.faq.banner_header' | translate"
    [iconAltText]="''"
    [hasCloseControl]="false"
    >
    <div class="faq-banner-content d-grid">
      <div class="c11n-text-md--crop">{{ 'contactUs.faq.banner_body' | translate }}</div>
      <div class="row c11n-text-md row-gap-1">
        <div class="col-lg-6">
          <a c11n-link target="_blank" href="../../assets/printables/MyCE FAQ.pdf" [iconName]="'download'" [iconPosition]="'leading'">{{ 'contactUs.faq.myce_faq_link' | translate }}</a>
        </div>
        <div class="col-lg-6">
          <a c11n-link target="_blank" href="../../assets/printables/MyCI FAQ.pdf" [iconName]="'download'" [iconPosition]="'leading'">{{ 'contactUs.faq.myci_faq_link' | translate }}</a>
        </div>
      </div>
    </div>
  </c11n-banner>
  <div class="contact-us-header center-content">{{ 'contactUs.title' | translate }}</div>
  <div class="contact-us-description center-content">
    {{ 'contactUs.description' | translate }}
  </div>
  <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()" class="contact-us-form" focusInvalidInput autocomplete="on">
      <div class="form-group-row">
        <div class="form-group">
          <label 
            for="formFieldFirstName" 
            class="form-label inputLabel">
            {{ 'formFields.firstName' | translate }}</label>
          <c11n-input 
            [size]="'medium'" 
            [hasError]="(contactUsForm.controls['firstName'].touched || isSubmitted) && contactUsForm.controls['firstName']?.errors">
            <input 
              c11nInput formControlName="firstName" 
              type="text" 
              class="form-control shadow-none"
              id="formFieldFirstName"
              autocomplete="given-name"
              maxlength="{{maxFullNameLength}}" 
              [attr.aria-describedby]="'first-name-description'"
              attr.aria-label="{{ 'formFields.firstName' | translate }}" />
          </c11n-input>
          <c11n-hint-error 
            [hasError]="(contactUsForm.controls['firstName'].touched || isSubmitted) && contactUsForm.controls['firstName'].getError(
              'required'
            )"
            *ngIf="(contactUsForm.controls['firstName'].touched || isSubmitted) && contactUsForm.controls['firstName'].getError(
              'required'
            )"
            [hintErrorId]="'first-name-description'" 
            errorText="{{ 'formErrors.firstName.required' | translate }}"
            [size]="'medium'">
          </c11n-hint-error>
          <c11n-hint-error 
            [hasError]="(contactUsForm.controls['firstName'].touched || isSubmitted) && contactUsForm.controls['firstName'].getError(
              'pattern'
            )"
            *ngIf="(contactUsForm.controls['firstName'].touched || isSubmitted) && contactUsForm.controls['firstName'].getError(
              'pattern'
            )"
            [hintErrorId]="'first-name-description'" 
            errorText="{{ 'formErrors.firstName.specialCharacters' | translate }}"
            [size]="'medium'">
          </c11n-hint-error>
        </div>
        <div class="form-group">
          <label 
            for="formFieldLastName" 
            class="form-label inputLabel">
            {{ 'formFields.lastName' | translate }}</label>
          <c11n-input 
            [size]="'medium'" 
            [hasError]="(contactUsForm.controls['lastName'].touched || isSubmitted) && contactUsForm.controls['lastName']?.errors">
            <input 
              c11nInput formControlName="lastName" 
              type="text" 
              class="form-control shadow-none"
              id="formFieldLastName"
              autocomplete="family-name"
              maxlength="{{maxFullNameLength}}" 
              [attr.aria-describedby]="'last-name-description'"
              attr.aria-label="{{ 'formFields.lastName' | translate }}" />
          </c11n-input>
          <c11n-hint-error 
            [hasError]="(contactUsForm.controls['lastName'].touched || isSubmitted) && contactUsForm.controls['lastName'].getError(
              'required'
            )"
            *ngIf="(contactUsForm.controls['lastName'].touched || isSubmitted) && contactUsForm.controls['lastName'].getError(
              'required'
            )"
            [hintErrorId]="'last-name-description'" 
            errorText="{{ 'formErrors.lastName.required' | translate }}"
            [size]="'medium'">
          </c11n-hint-error>
          <c11n-hint-error 
            [hasError]="(contactUsForm.controls['lastName'].touched || isSubmitted) && contactUsForm.controls['lastName'].getError(
              'pattern'
            )"
            *ngIf="(contactUsForm.controls['lastName'].touched || isSubmitted) && contactUsForm.controls['lastName'].getError(
              'pattern'
            )"
            [hintErrorId]="'last-name-description'" 
            errorText="{{ 'formErrors.lastName.specialCharacters' | translate }}"
            [size]="'medium'">
          </c11n-hint-error>
        </div>
      </div>

      <div class="form-group">
        <label 
          for="formFieldEmail" 
          class="form-label inputLabel">
          {{ 'formFields.email' | translate }}</label>
        <c11n-input 
          [size]="'medium'" 
          [hasError]="(contactUsForm.controls['email'].touched || isSubmitted) && 
            (contactUsForm.controls['email'].getError('required') || contactUsForm.controls['email'].getError('pattern'))">
          <input 
            c11nInput 
            formControlName="email" 
            autocomplete="email"
            type="email" 
            class="form-control shadow-none"
            id="formFieldEmail"
            maxlength="{{maxEmailLength}}"
            [attr.aria-describedby]="'email-description'"
            attr.aria-label="{{ 'formFields.email' | translate }}" />
        </c11n-input>
        <c11n-hint-error 
          [hasError]="(contactUsForm.controls['email'].touched || isSubmitted) && 
            contactUsForm.controls['email'].getError('required')"
          *ngIf="(contactUsForm.controls['email'].touched || isSubmitted) && 
            contactUsForm.controls['email'].getError('required')"
          [hintErrorId]="'email-description'"
          errorText="{{ 'formErrors.email.invalid' | translate }}" 
          [size]="'medium'">
        </c11n-hint-error>
        <c11n-hint-error 
          [hasError]="(contactUsForm.controls['email'].touched || isSubmitted) && contactUsForm.controls['email'].getError('pattern')"
          *ngIf="(contactUsForm.controls['email'].touched || isSubmitted) && contactUsForm.controls['email'].getError('pattern')"
          [hintErrorId]="'email-description'"
          errorText="{{ 'formErrors.email.invalid' | translate }}" 
          [size]="'medium'">
        </c11n-hint-error>
      </div>

      <div class="form-group-reason">
        <label 
          for="formFieldReason" 
          class="form-label inputLabel">
          {{ 'formFields.contactReason' | translate }}</label>
        <c11n-radio-group 
          groupId="formFieldReason"
          [hideLegend]="true"
          [hasCustomHintError]="true"
          [hasError]="(contactUsForm.controls['reason'].touched || isSubmitted) && contactUsForm.controls['reason'].getError(
            'required'
          )"
          legendText="{{ 'formFields.contactReason' | translate }}"
          >
          <div class="storybook-horizontal-radios">
            <div *ngFor="let reason of reasonsList; let i = index">
              <c11n-radio labelText="{{ 'contactUs.reason_options.' + reason.labelKey | translate }}">
                <input 
                  c11nRadioInput 
                  [id]="'formFieldReason' + i" 
                  type="radio" 
                  [value]="reason.value"
                  formControlName="reason"
                  name="reason"
                  [attr.aria-describedby]="'reason-description-' + i"
                  attr.aria-label="{{ reason.labelKey | translate }}"/>
              </c11n-radio>
            </div>
          </div>
        </c11n-radio-group>
        <c11n-hint-error
          [hasError]="(contactUsForm.controls['reason'].touched || isSubmitted) && contactUsForm.controls['reason'].getError(
            'required'
          )"
          *ngIf="(contactUsForm.controls['reason'].touched || isSubmitted) && contactUsForm.controls['reason'].getError(
            'required'
          )"
          [hintErrorId]="'reason-description'" 
          errorText="{{ 'formFields.required' | translate }}"
          [size]="'medium'">
        </c11n-hint-error>
      </div>

      <div class="form-group-message-subject">
        <c11n-select
          labelText="{{ 'formFields.messageSubject' | translate }}"
          size="medium"
          [hideLabel]="false"
          hintText=""
          [hasError]="(contactUsForm.controls['subject'].touched || isSubmitted) && contactUsForm.controls['subject'].getError(
            'required'
          )"
          errorText="{{ 'formFields.required' | translate }}"
          >
          <select c11nSelectInput formControlName="subject" required>
            <option value="" data-option="placeholder" selected disabled>{{ 'formFields.select' | translate }}</option>
            <option 
              *ngFor="let subject of subjectsList" 
              [value]="subject.value"
              [attr.aria-describedby]="subject.value"
              attr.aria-label="{{ 'contactUs.message_subject_options.' + subject.labelKey | translate }}"
              >{{ 'contactUs.message_subject_options.' + subject.labelKey | translate }}</option>
          </select>
        </c11n-select>
      </div>

      <div class="form-group-message">
        <label 
          for="formFieldMessage" 
          class="form-label inputLabel">
          {{ 'formFields.message' | translate }}</label>
        <c11n-textarea 
          [size]="'medium'" 
          [hasError]="(contactUsForm.controls['message'].touched || isSubmitted) && contactUsForm.controls['message'].getError(
            'required'
          )"
          errorText="{{ 'formFields.required' | translate }}"
          >
          <textarea 
            c11nTextarea 
            formControlName="message" 
            class="form-control shadow-none message-box"
            id="formFieldMessage"
            rows="10"
            maxlength="{{maxMessageLength}}" 
            [attr.aria-describedby]="'message-description'"
            attr.aria-label="formFields.message' | translate"></textarea>
        </c11n-textarea>
        <div class="flex-container">
          <div class="col-10">
            <c11n-hint-error 
              [hasError]="(contactUsForm.controls['message'].touched || isSubmitted) && contactUsForm.controls['message'].getError(
                'required'
              )" 
              *ngIf="(contactUsForm.controls['message'].touched || isSubmitted) && contactUsForm.controls['message'].getError(
                'required'
              )" 
              [hintErrorId]="'message-description'" 
              errorText="{{ 'formFields.required' | translate }}" [size]="'medium'">
            </c11n-hint-error>
            <c11n-hint-error 
              [hasError]="(contactUsForm.controls['message'].touched || isSubmitted) && contactUsForm.controls['message'].getError(
                'pattern'
              )" 
              *ngIf="(contactUsForm.controls['message'].touched || isSubmitted) && contactUsForm.controls['message'].getError(
                'pattern'
              )" 
              [hintErrorId]="'message-description'" 
              errorText="{{ 'formErrors.message.pattern' | translate }}" [size]="'medium'">
            </c11n-hint-error>
          </div>
          <div class="col-2">
            <p class="character-count">{{messageCharCount}}/{{maxMessageLength}}</p>
          </div>
        </div>
      </div>

      <div class="form-group">
        <re-captcha
          formControlName="captchaResponse" 
          [hasError]="true"
          siteKey="6LdApAYqAAAAAOQW_aWW2F_vYOZZU36XKu2dWfaU"
          [attr.aria-describedby]="'captchaResponse-description'"
          class="center-captcha">
        </re-captcha>
        <c11n-hint-error
          [hasError]="(contactUsForm.controls['captchaResponse'].touched || isSubmitted) && 
            contactUsForm.controls['captchaResponse'].getError('required')"
          *ngIf="(contactUsForm.controls['captchaResponse'].touched || isSubmitted) && 
            contactUsForm.controls['captchaResponse'].getError('required')"
          [hintErrorId]="'captchaResponse-description'"
          errorText="{{ 'formErrors.reCaptcha.required' | translate }}" 
          [size]="'medium'">
        </c11n-hint-error>
      </div>

      <div class="form-group center-content">
        <c11n-button
          labelText="{{ 'contactUs.submitBtn' | translate }}"
          buttonType="submit"
          size="medium"
          [isWaiting]="isSending"
          attr.aria-label="{{ 'contactUs.submitBtn' | translate }}"
          [attr.aria-describedby]="'submit-description'">
        </c11n-button>
      </div>
  </form>
</div>
<div *ngIf="emailSent" class="submit-confirmation">
  <div class="submit-icon">
    <img src="assets/images/green_checkmark.svg" alt="Green checkmark">
  </div>
  <div class="submit-confirmation-header">{{ 'contactUs.thankYou' | translate }}</div>
  <div class="submit-confirmation-message">
    {{ 'contactUs.feedback_received' | translate }}
  </div>
</div>